import { School } from './school'

export interface RecruiterProfile {
  id: string
  userId: string
  schoolId?: string // FK to schools table (stored value)
  school?: School // populated when joined in API responses
  position: string
  isVerified: boolean
  bio?: string
  profilePhoto?: string
  contactInfo: {
    firstName: string
    lastName: string
    phone: string
    email: string
    address?: {
      street: string
      city: string
      state: string
      zipCode: string
    }
  }
  recruitingFocus: {
    events: string[]
    academicRequirements: {
      minGPA?: number
      minSAT?: number
      minACT?: number
    }
  }
  createdAt: Date
  updatedAt: Date
}

export enum Division {
  NCAA_D1 = 'ncaa_d1',
  NCAA_D2 = 'ncaa_d2',
  NCAA_D3 = 'ncaa_d3',
  NAIA = 'naia',
  NJCAA = 'njcaa',
  CCCAA = 'cccaa',
  NWAC = 'nwac',
  NCCAA = 'nccaa',
  USCAA = 'uscaa',
}

export interface Subscription {
  id: string
  recruiterId: string
  stripeSubscriptionId: string
  status: SubscriptionStatus
  currentPeriodStart: Date
  currentPeriodEnd: Date
  cancelAtPeriodEnd: boolean
  createdAt: Date
  updatedAt: Date
}

export enum SubscriptionStatus {
  ACTIVE = 'active',
  CANCELED = 'canceled',
  INCOMPLETE = 'incomplete',
  INCOMPLETE_EXPIRED = 'incomplete_expired',
  PAST_DUE = 'past_due',
  TRIALING = 'trialing',
  UNPAID = 'unpaid',
}
